// NOTE: this is old style of exposing JS into the global context
// To properly use the <script type="module"> approach we will have to do work on webpack CI/CD pipeline and change this small code block to an export instead
window.eviivo = window.eviivo ? window.eviivo : {};
window.eviivo.auth = window.eviivo.auth ? window.eviivo.auth : {};
window.eviivo.auth.login = window.eviivo.auth.login ? window.eviivo.auth.login : {};

window.eviivo.auth.login = function () {
    const initLoginPage = async function (customOptions) {
        let elements = {};

        // in case we have an error we replace the state of the browser history with the root of the website (to be able to just hit a refresh page without hitting again a POST action)
        if (customOptions.isError) {
            if (typeof (window.history) != null) {
                window.history.replaceState(null, null, "/login");
            }
        }

        function setHtmlElements() {
            elements.buttonLogin = document.getElementById("btnLogin");
            elements.userInput = document.getElementById("txtUserName");
            elements.passwordInput = document.getElementById("txtPassword");
            elements.passwordReveal = document.getElementById("spPasswordReveal");
            elements.iconShowPassword = document.getElementById("icnShowPassword");
            elements.iconHidePassword = document.getElementById("icnHidePassword");
            elements.form = document.getElementById("frmLogin");
            elements.errorElement = document.querySelector(".mod-notice");
            elements.hdnDeviceFingerprint = document.getElementById("hdnDeviceFingerprint");
            elements.hdnDeviceFingerprintRaw = document.getElementById("hdnDeviceFingerprintRaw");
            elements.hdnHasDeviceFingerprintRawData = document.getElementById("hdnHasDeviceFingerprintRawData");
            elements.hdnCloudFlareTurnstileToken = document.getElementById("hdnCloudFlareTurnstileToken");
        }

        function setEventHandlers() {
            if (elements.form !== null) {
                elements.form.addEventListener("submit", async (e) => { e.preventDefault(); return await onSubmitForm(e); });
            }

            if (elements.passwordReveal !== null) {
                elements.passwordReveal.addEventListener("click", onPasswordReveal);
            }

            handleUserInputKeyPress();
        }

        function onPasswordReveal(e) {
            var passwordIsDisplayedData = elements.passwordReveal.dataset.passwordIsDisplayed;
            var passwordIsDisplayed = passwordIsDisplayedData != null && passwordIsDisplayedData.toLowerCase() == "true";

            revealPassword(passwordIsDisplayed);
            hidePassword(passwordIsDisplayed);
        }

        function revealPassword(passwordIsDisplayed) {
            if (elements.iconShowPassword !== null) {
                elements.iconShowPassword.classList.remove("hide");
                if (passwordIsDisplayed == false) {
                    elements.iconShowPassword.classList.add("hide");
                    elements.passwordInput.type = "text";
                    elements.passwordReveal.dataset.passwordIsDisplayed = true;
                }
            }
        }

        function hidePassword(passwordIsDisplayed) {
            if (elements.iconHidePassword !== null) {
                elements.iconHidePassword.classList.remove("hide");
                if (passwordIsDisplayed == true) {
                    elements.iconHidePassword.classList.add("hide");
                    elements.passwordInput.type = "password";
                    elements.passwordReveal.dataset.passwordIsDisplayed = false;
                }
            }
        }

        async function onSubmitForm(e) {
            //always force password input to "hide" the user input when clicking submit
            hidePassword(true);

            var isValid = true;
            if (elements.passwordInput !== null) {
                elements.passwordInput.classList.remove("input-validation-error");
                if (elements.passwordInput.value === null || elements.passwordInput.value === "") {
                    elements.passwordInput.classList.add("input-validation-error");
                    isValid = false;
                }
            }
            else {
                isValid = false;
            }

            if (elements.userInput !== null) {
                elements.userInput.classList.remove("input-validation-error");
                if (elements.userInput.value === null || elements.userInput.value === "") {
                    elements.userInput.classList.add("input-validation-error");
                    isValid = false;
                }
            } else {
                isValid = false;
            }

            // get the device fingerprint
            const deviceDetails = await eviivo.auth.deviceFingerprint.getDeviceFingerprint();
            let hasDeviceFingerprintData = deviceDetails.liteDetailsRawData != null;
            const rawData = JSON.stringify(deviceDetails.liteDetailsRawData);
            elements.hdnDeviceFingerprint.value = deviceDetails.liteDetailsFingerprint;
            elements.hdnDeviceFingerprintRaw.value = (hasDeviceFingerprintData ? rawData : null);
            elements.hdnHasDeviceFingerprintRawData.value = hasDeviceFingerprintData;

            const isTurnstileResolved = !customOptions.cloudflareTurnstileIsInUse || (customOptions.cloudflareTurnstileIsInUse && elements.hdnCloudFlareTurnstileToken.value.length > 1);

            //if valid and turnstile resolved
            if (isValid === true && isTurnstileResolved === true) {
                if (elements.form !== null) {
                    toggleLoginButtonState(false);
                    toggleErrorMessageState(false);
                    elements.form.submit();
                    return true;
                }
            }
            else {
                if (!isTurnstileResolved) {
                    toggleTurnstileBorder();
                }
                if (!isValid) {
                    setErrorState();
                }
            }

            return false;
        }

        function setErrorState() {
            toggleLoginButtonState(true);
            toggleErrorMessageState(true);
        }

        function toggleTurnstileBorder() {
            var turnstileElements = document.getElementsByClassName("s-turnstile-wrapper");
            if (turnstileElements != null && turnstileElements.length > 0) {
                turnstileElements[0].classList.add("alert-border");
            }
        }

        function toggleErrorMessageState(shouldShowError) {
            if (elements.errorElement !== null) {
                if (shouldShowError === true) {
                    elements.errorElement.classList.remove("hide");
                }
                else {
                    elements.errorElement.classList.add("hide");
                }
            }
        }

        function toggleLoginButtonState(shouldEnableButton) {
            if (elements.buttonLogin !== null) {
                if (shouldEnableButton === true) {
                    elements.buttonLogin.classList.remove("btn-saving");
                    elements.buttonLogin.removeAttribute("disabled");
                }
                else {
                    elements.buttonLogin.classList.add("btn-saving");
                    elements.buttonLogin.setAttribute("disabled", "disabled");
                }
            }
        }

        function handleUserInputKeyPress() {
            if (elements.userInput.addEventListener) {
                // For all major browsers, except IE 8 and earlier
                var event = document.createEvent("HTMLEvents");
                event.initEvent("click", false, false);
                event.eventName = "click";
                elements.passwordInput.addEventListener("keypress", function (e) {
                    if (e.keyCode === 13) {
                        elements.buttonLogin.dispatchEvent(event);
                    }
                });
            }
        }

        setHtmlElements();
        setEventHandlers();
    };


    return {
        initLoginPage
    }
}();